/**
 * Polyfills for browser compatibility
 * This file should be imported early in the application lifecycle
 */

// Promise.allSettled polyfill for older browsers
if (!Promise.allSettled) {
  Promise.allSettled = function(promises) {
    return Promise.all(
      promises.map(p => 
        Promise.resolve(p)
          .then(value => ({ status: 'fulfilled', value }))
          .catch(reason => ({ status: 'rejected', reason }))
      )
    );
  };
}

// Object.fromEntries polyfill (added in ES2019)
if (!Object.fromEntries) {
  Object.fromEntries = function(entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error('Object.fromEntries requires an iterable object');
    }
    
    return [...entries].reduce((obj, [key, value]) => {
      obj[key] = value;
      return obj;
    }, {});
  };
}

// String.prototype.replaceAll polyfill (added in ES2021)
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(search, replacement) {
    return this.split(search).join(replacement);
  };
}

// Array.prototype.flat polyfill (added in ES2019)
if (!Array.prototype.flat) {
  Array.prototype.flat = function(depth = 1) {
    return function flatten(arr, depth) {
      if (depth === 0) return arr.slice();
      return arr.reduce((acc, val) => {
        return acc.concat(Array.isArray(val) && depth > 0
          ? flatten(val, depth - 1)
          : val);
      }, []);
    }(this, depth);
  };
}

// Element.matches & Element.closest polyfills for older browsers
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// requestAnimationFrame polyfill
if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = function(callback) {
    return setTimeout(function() { callback(Date.now()); }, 16);
  };
  
  window.cancelAnimationFrame = function(id) {
    clearTimeout(id);
  };
}